import { render, staticRenderFns } from "./health_info.vue?vue&type=template&id=4824c8ce&scoped=true&"
import script from "./health_info.vue?vue&type=script&lang=js&"
export * from "./health_info.vue?vue&type=script&lang=js&"
import style0 from "./health_info.vue?vue&type=style&index=0&id=4824c8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824c8ce",
  null
  
)

export default component.exports